// extracted by mini-css-extract-plugin
export default {"signin":"signin_signin__fWCgT","container":"signin_container__wrW7q","form":"signin_form__Tj63b","rotate":"signin_rotate__JJMkZ"};